export const PATCH_HEADERS = {
    headers: {
        'Content-Type': 'application/vnd.api+json',
    },
};
